import CertificateCard from '../Components/Achivements/CertificateCard'
import Certificates from '../Components/Achivements/Certificates'
import Credentials from '../Components/Achivements/Credentials'

const Certifications = () => {
  return (
    <div className='circularstd'>
      <Certificates />
      <CertificateCard />
      <Credentials />
    </div>
  )
}

export default Certifications